import React from 'react';

import Box from '@mui/material/Box';

const PageContainer = ({children}) => {

    return(

        <Box component='section' 
            sx={{display: 'flex'}}
        >

            {children}

        </Box>

    );
};

export default PageContainer;